module.exports = __webpack_public_path__ + "img/rouler_positions_7.773ef948.png";